import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
export { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { omit } from "keautils";
import { fa } from "typed-font-awesome";
import { DireccionComponent } from "app/features/componentes/direccion/direccion";
import { componentToRx } from "app/logic/rx";
export interface Props<TEntity> {
    value?: TEntity;
    onChange?: (value: TEntity) => PromiseLike<void> | void;
    label?: string;
    error?: kea.FieldError;
    readonly?: boolean;
}

export function obtenerComponenteDireccionColonia<TEntity>(idColonia: keyof TEntity, direccion: keyof TEntity, defaultLabel: string): React.ComponentClass<Props<TEntity>> {

    function mapValue(c: TEntity | {}): models.DireccionColonia {
        return {
            ... ((c as any)[direccion] as any),
            IdColonia: (c as any)[idColonia]
        };
    }

    function mapChange(change: models.DireccionColonia, old: TEntity | {}): TEntity {
        return {
            ... (old as any),
            [direccion]: omit(change, ["IdColonia"]),
            [idColonia]: change.IdColonia
        };  
    }

    const ret = class DireccionColoniaMapeado extends React.PureComponent<Props<TEntity>> {
        onChange = async (x: models.DireccionColonia) => {
            if (this.props.onChange) {
                await this.props.onChange(mapChange(x, this.props.value || {}));
            }
        }

        render() {
            const value = mapValue(this.props.value || {});

            return <DireccionComponent value={value} onChange={this.onChange} label={this.props.label} error={this.props.error} readonly={this.props.readonly} />;
        }
    }

    return ret;
}


// WEBPACK FOOTER //
// ./app/features/componentes/direccioncolonia.tsx